import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';
import {
  types as actions,
  resetPasswordCompletedAction,
  errorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.RESET_PASSWORD),
    switchMap(action =>
      AuthService.setPasswordWithToken(action.email, action.token, action.password).pipe(
        map(() => resetPasswordCompletedAction(action.email)),
        catchError(error => of(errorAction(error)))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/auth/resetPassword.js